import { Section } from '@tracsis/library/src';
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

const AnchorSection = ({
	children,
	id,
	setActiveHeading,
}: {
	children: React.ReactNode;
	id: string;
	setActiveHeading: any;
}) => {
	const { ref, inView } = useInView({
		threshold: 0,
		rootMargin: '-25% 0% -75%',
		triggerOnce: false,
	});
	useEffect(() => {
		if (inView) setActiveHeading(id);
	}, [inView]);

	return (
		<div ref={ref}>
			<Section id={id}>{children}</Section>
		</div>
	);
};

export default AnchorSection;
